module.exports = __webpack_public_path__ + "img/hometh1.ac6a2120.png";